/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MSP09Dto { 
    rkey?: string | null;
    rvalue?: string | null;
    saccosName?: string | null;
    mspcode?: string | null;
    monthEndedValue?: string | null;
    memberShare?: number | null;
    voluntaryShares?: number | null;
    otherShares?: number | null;
    fixedAssestRevalution?: number | null;
    transitoryCapital?: number | null;
    donationsAndGrants?: number | null;
    reserveFunds?: number | null;
    retainedEarnings?: number | null;
    plCurrentYear?: number | null;
    totatCoreCapitalSum?: number | null;
    totalInstitutionalLessSum?: number | null;
    totalInstitutionalSum?: number | null;
    totalAssets?: number | null;
    coreCapitalRatio?: number | null;
    institutionalCapitalRatio?: number | null;
    netInstitutionalCapitalRatio?: number | null;
}

